exports.f = require('./_wks');


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_wks-ext.js
// module id = 147
// module chunks = 0